import React, { useEffect, useState } from 'react';
import { useQuoteStore } from "../../../hooks/quote";
import { DateRangePicker } from 'rsuite';
import moment from 'moment'
import Helper from 'src/helper/Helper';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import Constants from "../../../helper/Constants";
import System from "../../../helper/system";


const QuoteAdvanceFilterPopup = (props) => {
    const { SetStatus } = props
    const defaulDateRange = "";
    const [dateRangeObject, set_dateRangeObject] = useState(defaulDateRange);
    const [expDateRangeObject, set_exp_dateRangeObject] = useState(defaulDateRange);
    const [{ filter_list }, {}, { set_filter_list }] = useObjCommonFilterStore();
    const filterDetail = {
        quoteNumber: '',
        manufacturerPartNumber: '',
        customerPartNumber: "",
        quoteReasonType: "",
        manufacturer: "",
        buyer: "",
        status: {}
    };
    const [{ statusList }, { }, { clear_quote_list }] = useQuoteStore();
    const [formData, setFormData] = useState(filterDetail)
    const [validationDetail, setValidationDetail] = useState({});
    const charMsg = "Please enter at least 3 characters to execute a keyword search.";
    const { siteUser } = Constants;

    const searchParams = {
        quoteNumber: "Quote Number",
        manufacturerPartNumber: "Manufacturer Part Number",
        customerPartNumber: "Customer Part Number",
        manufacturer: "Manufacturer",
        submissionDate: "Submission Date",
        expirationDate: "Expiration Date",
        status: "Quote Status",
        buyer: "Buyer",
        projectName: "Project Name",
    }

    useEffect(() => {
        const filterData = {
            quoteNumber: filter_list.quoteNumber?.searchKeyword,
            manufacturerPartNumber: filter_list.manufacturerPartNumber?.searchKeyword,
            customerPartNumber: filter_list.customerPartNumber?.searchKeyword,
            manufacturer: filter_list.manufacturer?.searchKeyword,
            submissionDate: setInitialDateVal(filter_list.submissionDate?.searchKeyword),
            expirationDate: setInitialDateVal(filter_list.expirationDate?.searchKeyword),
            buyer: filter_list.buyer?.searchKeyword,
            projectName: filter_list.projectName?.searchKeyword,
            status: filter_list.status?.searchKeywordArr.reduce((value = {}, ele) => {
                value[ele.key] = true;
                return value;
            }, {}) || {},
        }
        setFormData(filterData)
        set_dateRangeObject(filterData.submissionDate)
        set_exp_dateRangeObject(filterData.expirationDate)
    }, [filter_list]);

    const setInitialDateVal = (dtObj) => {
        if (!dtObj) {
            return defaulDateRange;
        }
        const _dt = dtObj.split("-");
        _dt[0] = new Date(_dt[0]);
        _dt[1] = new Date(_dt[1]);
        return _dt;
    }

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onValueChange = (field, value) => {
        setFormData({ ...formData, [field]: value })
        validateOnChange(field, value);
    }

    const onSelectStatus = (e) => {
        formData.status[e.target.value] = e.target.checked;
        setFormData({ ...formData });
    }

    const validateOnChange = (field, value) => {
        if (field === 'buyer' || field === 'customerPartNumber' || field === 'manufacturer' || field === 'manufacturerPartNumber' || field === 'quoteNumber') {
            if (value) {
                const isValid = Helper.validateMinCharacter(value);
                if (isValid) {
                    const validateData = { ...validationDetail };
                    delete validateData[field];
                    setValidationDetail(validateData)
                }
            } else {
                const validateData = { ...validationDetail };
                delete validateData[field];
                setValidationDetail(validateData)
            }
        }
    }

    const onApplyFilter = () => {
        const isValid = checkValidation(formData);
        if (isValid) {
            const filterData = {}
            Object.assign(filterData, formData)
            if (dateRangeObject && dateRangeObject.length > 0 && dateRangeObject[0] && dateRangeObject[1]) {
                filterData.submissionDate = setDateForFilter(dateRangeObject);
            }
            if (expDateRangeObject && expDateRangeObject.length > 0 && expDateRangeObject[0] && expDateRangeObject[1]) {
                filterData.expirationDate = setDateForFilter(expDateRangeObject);
            }
            const quoteSearch = {};
            const dataArr = Object.entries(filterData).filter(([key, value]) => {
                if (key === "status") {
                    return Object.entries(value)?.filter(([key, value]) => {
                        return !!value;
                    }).length > 0;
                }
                return !!value
            })
            if (dataArr.length === 0) {
                clear_quote_list();
                onHide();
                return;
            }
            Object.entries(filterData).forEach(([key, value]) => {
                if (!value || key === "status") {
                    return;
                }
                quoteSearch[key] = {
                    searchType: searchParams[key],
                    searchKeyword: value
                };
            });
            if (Object.keys(filterData.status)?.length > 0) {
                quoteSearch.status = {
                    searchType: searchParams.status,
                    searchKeywordArr: Object.keys(filterData.status)?.filter((key) => {
                        return filterData.status[key];
                    })?.map(ele => ({
                        label: statusList[ele].text,
                        value: statusList[ele].text,
                        key: ele
                    }))
                };
            }

            set_filter_list(quoteSearch)
            onHide();
        }
    }

    useEffect(() => {
        if (dateRangeObject[0] !== null)
            setDateForFilter(dateRangeObject);
    }, [dateRangeObject])

    useEffect(() => {
        if (expDateRangeObject[0] !== null)
            setDateForFilter(expDateRangeObject);
    }, [expDateRangeObject])

    const setDateForFilter = (dtObj) => {
        if (dtObj[0] && dtObj[1]) {
            const dt1_frm = moment(dtObj[0]).local().format(Helper.getDatepickerFormat().toUpperCase());
            const dt2_frm = moment(dtObj[1]).local().format(Helper.getDatepickerFormat().toUpperCase());
            return dt1_frm + ' - ' + dt2_frm;
        }
        return '';
    }

    const checkValidation = (data) => {
        const validateData = {};
        Object.keys(data).forEach((property) => {
            if (property === 'buyer' || property === 'customerPartNumber' || property === 'manufacturer' || property === 'manufacturerPartNumber' || property === 'quoteNumber' || property === 'projectName') {
                if (data[property]) {
                    const isValid = Helper.validateMinCharacter(data[property]);
                    if (isValid === false) {
                        validateData[property] = charMsg;
                    } else {
                        delete validateData[property];
                    }
                } else {
                    delete validateData[property];
                }
            }
        });

        setValidationDetail(validateData)
        return Object.keys(validateData).length <= 0;
    }

    const onSetDateRange = (dates) => {
        if (dates) {
            set_dateRangeObject(dates)
        } else {
            set_dateRangeObject(defaulDateRange)
        }
    }
    const onSetExpDateRange = (e) => {
        if (e) {
            set_exp_dateRangeObject(e)
        } else {
            set_exp_dateRangeObject(defaulDateRange)
        }
    }
    const isPendingStatus = (status) => {
        let isDisabled = false;
        if (status === 'P') {
            isDisabled = (formData?.A === "A" || formData?.B === "B" || formData?.E === "E" || formData?.R === "R");
        } else {
            isDisabled = (formData?.P === "P");
        }
        return isDisabled;
    }

    return (
        <>
            <div className=" avnet-modal modal-550">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                    </button>
                    <div className="modal-header">
                        <h4 className="modal-title text-center">Filter Quotes</h4>
                    </div>
                    <form id="hook-form">
                        <div className="modal-body">
                            <div className="popup-subheader">FILTER BY DATES</div>
                            <div className="row bs5">
                                <div className="form-group col-6">
                                    <label htmlFor="usr">Quote Submission Date</label>
                                    <DateRangePicker
                                        style={{ width: '100% !important' }}
                                        placeholder="Date Range"
                                        onChange={(dates, event) => {
                                            onSetDateRange(dates);
                                        }}
                                        value={dateRangeObject}
                                        ranges={[]}
                                        character=" - "
                                        cleanable={false}
                                        format={Helper.getDatepickerFormat()}
                                        editable={false}
                                        className="w-100 datepickerinputdisable"
                                    />
                                </div>
                                <div className="form-group col-6">
                                    <label htmlFor="usr">Quote Expiration Date</label>
                                    <DateRangePicker
                                        style={{ width: '100% !important' }}
                                        placeholder="Date Range"
                                        onChange={(dates, event) => {
                                            onSetExpDateRange(dates);
                                        }}
                                        value={expDateRangeObject}
                                        ranges={[]}
                                        character=" - "
                                        cleanable={false}
                                        format={Helper.getDatepickerFormat()}
                                        editable={false}
                                        className="w-100 datepickerinputdisable"
                                    />
                                </div>
                            </div>
                            <div className="filter-by-status mb-4">
                                <div className="popup-subheader">FILTER BY STATUS</div>
                                <div className="filter-by-status-checkboxes d-flex justify-content-between">
                                    {statusList && Object.keys(statusList).map((v) => (
                                        <section className="form-check form-check-inline sm-custom_checkbox" key={v}>
                                            <input type="checkbox" className="form-check-input"
                                                   disabled={isPendingStatus(v)} id={statusList[v].id}
                                                   name={statusList[v].text} value={v}
                                                   onChange={onSelectStatus} checked={formData.status[v]}/>
                                            <label className="form-check-label mt-0"
                                                   htmlFor={statusList[v].id}>{statusList[v].text}</label>
                                        </section>
                                    ))}
                                </div>
                            </div>

                            <div className="row bs5">
                                <div className="form-group col-6">
                                    <label htmlFor="manufacturer">Manufacturer</label>
                                    <input type="text" className="form-control" id="manufacturer"
                                           placeholder="Manufacturer" value={formData.manufacturer}
                                           onChange={({ target: { value } }) => onValueChange('manufacturer', value)}/>
                                    {validationDetail.manufacturer &&
                                        <span className="required-alert">{validationDetail.manufacturer}</span>}
                                </div>
                                <div className="form-group col-6">
                                    <label htmlFor="manufacturerPartNumber">Manufacturer Part Number</label>
                                    <input type="text" className="form-control" id="manufacturerPartNumber"
                                           placeholder="Manufacturer Part Number"
                                           value={formData.manufacturerPartNumber}
                                           onChange={({ target: { value } }) => onValueChange('manufacturerPartNumber', value)}/>
                                    {validationDetail.manufacturerPartNumber && <span
                                        className="required-alert">{validationDetail.manufacturerPartNumber}</span>}
                                </div>
                                {System.avUserInfoData.currentUser === siteUser.CORE &&
                                  <div className="form-group col-6">
                                      <label htmlFor="customerPartNumber">Customer Part Number</label>
                                      <input type="text" className="form-control" id="customerPartNumber"
                                             placeholder="Customer Part Number"
                                             value={formData.customerPartNumber}
                                             onChange={({ target: { value } }) => onValueChange('customerPartNumber', value)}
                                      />
                                      {validationDetail.customerPartNumber &&
                                        <span className="required-alert">{validationDetail.customerPartNumber}</span>}
                                  </div> }
                                <div className="form-group col-6">
                                    <label htmlFor="quoteNumber">Quote Number</label>
                                    <input type="text" className="form-control" id="quoteNumber"
                                           placeholder="Quote Number"
                                           value={formData.quoteNumber}
                                           onChange={({ target: { value } }) => onValueChange('quoteNumber', value)}/>
                                    {validationDetail.quoteNumber &&
                                      <span className="required-alert">{validationDetail.quoteNumber}</span>}
                                </div>
                                <div className="form-group col-6">
                                    <label htmlFor="buyer">Buyer</label>
                                    <input type="text" className="form-control" id="buyer" placeholder="Buyer"
                                           value={formData.buyer}
                                           onChange={({ target: { value } }) => onValueChange('buyer', value)}/>
                                    {validationDetail.buyer &&
                                        <span className="required-alert">{validationDetail.buyer}</span>}
                                </div>
                                <div className="form-group col-6">
                                    <label htmlFor="projectName">Project Name</label>
                                    <input type="text" className="form-control" id="projectName"
                                           placeholder="Project Name"
                                           value={formData.projectName}
                                           onChange={({ target: { value } }) => onValueChange('projectName', value)}/>
                                    {validationDetail.projectName &&
                                        <span className="required-alert">{validationDetail.projectName}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer text-center">
                            <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                                    onClick={() => {
                                        onHide()
                                    }}>Close
                            </button>
                            <button type="button" className="bs5 btn btn-primary w145" onClick={onApplyFilter}>Apply
                                filters
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default QuoteAdvanceFilterPopup;